






































































import { Vue, Component, Prop } from "vue-property-decorator";
import { getCurrentCompanyId } from "@/plugins/roles";
import CPageButtons from "@/components/form/CustomPage/CPageButtons.vue";
import { UsersListClass } from "@/classes/list/UsersListClass";
import { ConditionsListClass } from "@/classes/list/ConditionsListClass";
import CSingleSelect from "@/components/form/CSingleSelect.vue";
import { Agent as IAgent } from "@/api-v2/agent/models/agent";
import { User as IUser } from "@/api/models/user";
import { Condition as ICondition } from "@/api-v2/agent/models/condition";

@Component({
  components: { CSingleSelect, CPageButtons }
})
export default class AgentForm extends Vue {
  @Prop() agent?: IAgent;
  @Prop({ default: false }) isLoading?: boolean;
  usersList: UsersListClass = new UsersListClass({});
  conditionsList: ConditionsListClass = new ConditionsListClass();
  agentForm: IAgent = {
    companyId: this.agent?.companyId ?? this.companyId,
    conditionId: this.agent?.conditionId ?? "",
    firstName: this.agent?.firstName ?? "",
    lastName: this.agent?.lastName ?? "",
    middleName: this.agent?.middleName ?? "",
    id: this.agent?.id ?? undefined,
    userId: this.agent?.userId ?? ""
  };

  get companyId() {
    return getCurrentCompanyId();
  }

  setUser(user: IUser) {
    this.agentForm.firstName = user.firstName ?? "";
    this.agentForm.lastName = user.lastName ?? "";
    this.agentForm.middleName = user.middleName ?? "";
  }

  setCondition(condition: ICondition) {
    this.agentForm.conditionTitle = condition.title ?? "";
  }

  onSubmit() {
    this.$emit("save", this.agentForm);
  }

  onCancel() {
    this.$emit("cancel");
  }

  onRemove() {
    this.$emit("delete", this.agentForm?.id);
  }
}
